<template>
    <div 
        v-if="socials.length > 0" 
        class="social-media"
    >
        <a 
            v-for="(social, index) in socials"
            :key="index"
            :href="social.url" 
            target="_blank"
            rel="noopener noreferrer"
            class="social-item"    
        >
            <i :class="social.iconClass" />
        </a>
    </div>
</template>

<script>
export default {
    computed: {
        data() {
            return this.$store.state.footer;
        },
        socials() {
            return [
                {
                    url: this.data.facebook?.url,
                    iconClass: 'fa-brands fa-square-facebook fa-xl',
                    validate: this.$validateText(this.data.facebook?.url),
                },
                {
                    url: this.data.tiktok?.url,
                    iconClass: 'fa-brands fa-tiktok fa-xl',
                    validate: this.$validateText(this.data.tiktok?.url),
                },
                {
                    url: this.data.trustpilot?.url,
                    iconClass: 'fa-kit fa-trustpilot fa-xl',
                    validate: this.$validateText(this.data.trustpilot?.url),
                }
            ].filter(social => social.validate);
        }
    },
};
</script>

<style lang="scss" scoped>
    .social-media {
        margin-top: 1rem;
        display: flex;
        align-items: baseline;
        column-gap: 10px;
        @include device(mobile) {
            justify-content: center;
        }
        .social-item {
            color: $white;

            &:hover {
                transition: 0.15s ease-in-out;
                transform: scale(1.1);
            }
        }
    }
</style>